import React, { useState } from 'react'
import OpenComponent from './OpenComponent/OpenComponent'
import MyComponent from './MyComponent/MyComponent'

const BodyContribute = () => {
    const [activeButton, setActiveButton] = useState("openCompo")
    const handleMyComponent = () => {
        setActiveButton("myCompo")
    }
    const handleOpenComponent = () => {
        setActiveButton("openCompo")
    }
    return (
        <div className='w-[95%] m-auto bg-white p-6 pt-3 rounded-lg shadow-custom'>
            <div className=''>
                <button className={`p-3 pb-3 ${activeButton === "openCompo" ? 'text-[#1976d2] border-[#1976d2] border-b-2' : 'text-[#00000099]'}`} onClick={handleOpenComponent}>Open Component</button>
                <button className={`p-3 pb-3 ${activeButton === "myCompo" ? 'text-[#1976d2] border-[#1976d2] border-b-2' : 'text-[#00000099]'}`} onClick={handleMyComponent}>My Component</button>
            </div>
            <div>
                {activeButton === "openCompo" ? <OpenComponent /> : <MyComponent />}
            </div>
        </div>
    )
}

export default BodyContribute